import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { RiskConsequences, riskConsequencesOptions } from 'src/api/types';
import { ActionMeta, Props, Theme } from 'react-select';
import { DefaultTheme } from 'styled-components';

type Option = { label: string; value: RiskConsequences };
type OptionGroup = { label: string; options: Option[] };

interface ConsequencesSelectProps extends Omit<Props<Option>, 'value'> {
  theme?: Theme & DefaultTheme;
  value?: RiskConsequences | null;
  onChange?: (value: Option, meta: ActionMeta<Option>) => void;
}

const getValue = (opts: (Option | OptionGroup)[], val?: RiskConsequences | null) => {
  const data = opts.reduce<Option[]>((acc, curr) => {
    if ('options' in curr) {
      return [...acc, ...curr.options];
    } else {
      return [...acc, curr];
    }
  }, []);

  return data.find((o) => o.value === val) || null;
};

export const ConsequencesSelect: React.FC<ConsequencesSelectProps> = ({ value, ...other }) => {
  return (
    <>
      <CSelect
        value={getValue(riskConsequencesOptions, value)}
        placeholder="Select consequence"
        options={riskConsequencesOptions}
        inputId="consequences-select"
        {...other}
      />
      {other.error && other.helperText && <Error>{other.helperText}</Error>}
    </>
  );
};
